import React from "react";

import payMaya from "../../images/paymaya-logo.png";
import myeg from "../../images/myeg-logo.jpg";
import ubLogo from "../../images/ub-logo.png";
import msLogo from "../../images/multisys.png";
import keriLogo from "../../images/keri-logo.png";
import starpayLogo from "../../images/starpay-logo.jpg";

const Footer = (props) => {
  const isEnabled = (opt) => {
    if (props.options) {
      const option = props.options.find((_) => _.type === opt);
      return option ? option.enabled : false;
    } else return false;
  };

  return (
    <div id="footer" className="w-screen border-t bg-green-900 p-3">
      <div className="mx-auto flex gap-4 h-10">
        {isEnabled("paymaya") && (
          <div className=" bg-white rounded w-24 p-1">
            <img src={payMaya} alt="paymaya" className="h-full mx-auto" />
          </div>
        )}

        {isEnabled("myeg") && (
          <div className=" bg-white rounded w-24 p-1">
            <img src={myeg} alt="myeg" className="h-full mx-auto" />
          </div>
        )}

        {isEnabled("union-bank") && (
          <div className=" bg-white rounded w-24 p-1">
            <img src={ubLogo} alt="union-bank" className="h-full mx-auto" />
          </div>
        )}

        {isEnabled("starpay") && (
          <div className=" bg-white rounded w-24 p-1">
            <img src={starpayLogo} alt="starpay" className="h-full mx-auto" />
          </div>
        )}

        {isEnabled("multi-sys") && (
          <div className=" bg-white rounded w-24 p-1">
            <img src={msLogo} alt="multi-sys" className="h-full mx-auto" />
          </div>
        )}

        {isEnabled("keri") && (
          <div className="bg-white rounded w-24 p-1">
            <img src={keriLogo} alt="keridelivery" className="h-full mx-auto" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
